export default __webpack_public_path__ + "559199bcf1305e552e92a1c2e6a3618a.png";